export default __webpack_public_path__ + "static/media/IMG_4527-min.f2d920e4.JPG";